/**
 * Query keys factory для thoughts - СТРОГО по бэкенду
 * Поддерживает только реальные endpoints
 */

export const thoughtKeys = {
	all: ["thoughts"] as const,
	lists: () => [...thoughtKeys.all, "list"] as const,
	list: (userId: number) => [...thoughtKeys.lists(), userId] as const,
	details: () => [...thoughtKeys.all, "detail"] as const,
	detail: (userId: number, thoughtId: number) =>
		[...thoughtKeys.details(), userId, thoughtId] as const,
} as const
